import {
  UPDATE_GHETTORADIO_GROUPS,
  UPDATE_GHETTORADIO_TIMER,
  UPDATE_GHETTORADIO_LOCKED,
  UPDATE_GHETTORADIO_HANDLING_ACTION,
  UPDATE_PROJECT,
  UPDATE_GROUP,
  UPDATE_GHETTORADIO_ACTIVE
} from '../actions/types';

const initialState = {
  SchoolClass: {
    className: '',
    classRoom: '',
  },
  loaded: false,
  GroupTheme: {},
  grGroups: { loaded: false },
  ghettoRadioHandlingAction: false,

};

const group = (state = initialState, action) => {
  const { payload, type } = action;
  switch (type) {
    case UPDATE_PROJECT:
      if (state.ghettoRadioHandlingAction === UPDATE_GHETTORADIO_ACTIVE) {
        state.ghettoRadioHandlingAction = false;
      }
      return {
        ...state,
        ...payload.group,
      };

    case UPDATE_GROUP:
      return {
        ...state,
        ...payload,
      };
    case UPDATE_GHETTORADIO_HANDLING_ACTION:
      state.ghettoRadioHandlingAction = payload;
      return {
        ...state,
      };
    case UPDATE_GHETTORADIO_GROUPS:
      return {
        ...state,
        grGroups: {
          ...payload,
          loaded: true,
        },
      };
    case UPDATE_GHETTORADIO_TIMER:
      if (state.ghettoRadioHandlingAction === UPDATE_GHETTORADIO_TIMER) {
        state.ghettoRadioHandlingAction = false;
      }
      return {
        ...state,
        grGroups: {
          ...state.grGroups,
          Groups: state.grGroups.Groups.map((grp) => {
            grp.GhettoRadioGroup = grp.GhettoRadioGroup || {};
            grp.GhettoRadioGroup.timerExpiresAt = payload;
            return grp;
          }),
        }
      };
    case UPDATE_GHETTORADIO_LOCKED:
      if (state.ghettoRadioHandlingAction === UPDATE_GHETTORADIO_LOCKED) {
        state.ghettoRadioHandlingAction = false;
      }
      return {
        ...state,
        grGroups: {
          ...state.grGroups,
          Groups: state.grGroups.Groups.map((grp) => {
            grp.GhettoRadioGroup = grp.GhettoRadioGroup || {};
            grp.GhettoRadioGroup.locked = payload;
            return grp;
          }),
        }
      };
    default:
      return state;
  }
};

export default group;



// WEBPACK FOOTER //
// ./src/reducers/group.js